import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cn from 'classnames';
import omit from 'lodash/omit';
import css from './css.css';
import appBarDialogs from "~/ui/AppBar/appBarDialogs";
import { Dialog } from "~/native-ui"
import { withResponsivePropsResolved } from '../../hoc/withResponsiveProps';

const ResponsiveDialog = withResponsivePropsResolved(Dialog);

export default class AppBarDialog extends Component {
	static propTypes = {
        activeAppBarDialog: PropTypes.string,
		onClose: PropTypes.func.isRequired
	};

    initialFocusRef = React.createRef(null);

	isActive = (props = this.props) => {
        let { activeAppBarDialog } = props;

        return activeAppBarDialog && activeAppBarDialog in appBarDialogs;
	};

    componentDidUpdate(prevProps) {
		if (this.isActive() && !this.isActive(prevProps)) {
			return document.body.addEventListener('keydown', this.handleEscKey);
		}

		if (!this.isActive() && this.isActive(prevProps)) {
			return document.body.removeEventListener('keydown', this.handleEscKey);
		}
    }

    componentWillUnmount() {
		document.body.removeEventListener('keydown', this.handleEscKey);
    }

    handleEscKey = (e) => {
        if (this.isActive() && e.which === 27) {
            return this.props.onClose(e);
        }
    };

    handleOverlayClick = (event) => {
        event?.preventDefault();
        event?.stopPropagation();
		this.props.onClose();
    };

    renderContent = () => {
        if(this.isActive()) {
            let DialogComponent = appBarDialogs[this.props.activeAppBarDialog];

			return <DialogComponent initialFocusRef={ this.initialFocusRef } />
        }

        return null;
    };

    modalContentProps = { focusable: false };
	render() {
	    let className = cn([css.dialogWrapper, this.props.className], {
             [css.dialogActive]: this.isActive()
        });

        const dialogProps = {
            active: this.isActive(),
            onOverlayClick: this.handleOverlayClick,
            showCloseButton: false,
            marginBottom: "auto",
            marginTop: 53,
            type: "large",
            initialFocusRef: this.initialFocusRef,
            _web: this.modalContentProps,
            ...omit(this.props, Object.keys(AppBarDialog.propTypes)),
        }

		return (
            <React.Fragment>
                <ResponsiveDialog {...dialogProps} >
                    {this.renderContent()}
                </ResponsiveDialog>
            </React.Fragment>
		);
	}
}